export default "__VITE_PUBLIC_ASSET__cdd3de63__"